module.exports = __webpack_public_path__ + "static/media/paga-rapido-computer.4268de73.png";